import circleImage from '@/assets/svg/circle.svg'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const REASON_ITEMS = [
  {
    image: '5fc8375d17a96ad64dd95dc2bd08bc4b.png',
    titleKey: 'aboutUs.whyChoose.items.oneStop.title',
    descriptionKey: 'aboutUs.whyChoose.items.oneStop.description',
  },
  {
    image: '490e38bed647e4d34298d42fa53a04fd.png',
    titleKey: 'aboutUs.whyChoose.items.officialChannels.title',
    descriptionKey: 'aboutUs.whyChoose.items.officialChannels.description',
  },
  {
    image: '34d6db3731a36267033c204aa03a80f9.png',
    titleKey: 'aboutUs.whyChoose.items.languageSupport.title',
    descriptionKey: 'aboutUs.whyChoose.items.languageSupport.description',
  },
  {
    image: 'aa9b5776cc6b8df6c50c4930a3a3de3f.png',
    titleKey: 'aboutUs.whyChoose.items.benefits.title',
    descriptionKey: 'aboutUs.whyChoose.items.benefits.description',
  },
] as const

const WhyChooseUs = () => (
  <section className="w-full bg-[#FAFAFA] py-[60px]">
    <div className="mx-auto w-[1200px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="aboutUs.whyChoose.title"
          className="text-[36px] font-bold leading-[50px] text-[#000]"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
      </div>

      <div className="mt-[48px] grid grid-cols-2 gap-[32px]">
        {REASON_ITEMS.map((item) => (
          <article
            key={item.titleKey}
            className="group relative flex h-[224px] items-center overflow-hidden rounded-[20px] border border-[#E3DCDD] px-[32px] transition-[border-color,box-shadow,transform] duration-300 ease-out hover:border-primary/30 hover:shadow-[0_12px_28px_rgba(50,139,248,0.10)]"
            style={{
              background: 'linear-gradient(180deg, #FFF7F2 0%, #EDF5FF 100%)',
            }}
          >
            <img
              src={preFixImgUrl(item.image)}
              alt=""
              className="relative z-[2] h-[160px] w-[160px] shrink-0 object-contain transition-transform duration-300 ease-out group-hover:scale-110"
              draggable={false}
            />

            <div className="relative z-[2] ml-[24px] min-w-0 flex-1 text-center">
              <LangText
                lngKey={item.titleKey}
                className="inline-block font-smiley-sans text-[32px] font-medium leading-[38px] text-primary transition-[color,transform] duration-300 ease-out group-hover:translate-x-[3px] group-hover:text-[#126FD9]"
              />
              <LangText
                lngKey={item.descriptionKey}
                className="mt-[16px] block whitespace-pre-line text-[20px] leading-[28px] text-[#979797] transition-colors duration-300 group-hover:text-[#777777]"
              />
            </div>

            <img
              src={circleImage}
              alt=""
              className="pointer-events-none absolute bottom-[-164px] right-[-112px] z-[1] h-[306px] w-[306px] transition-transform duration-500 ease-out group-hover:scale-125"
              aria-hidden
            />
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default WhyChooseUs
